import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/dashboard/app/global-error.tsx");
